// ═══ Supabase — Zentraler Re-Export ═══
// Alle Consumer importieren weiterhin: import { db } from '../../lib/supabase.js'
// Vite löst "supabase.js" → "supabase/index.js" automatisch auf.

export { _sb, SUPABASE_URL, SUPABASE_ANON_KEY } from './client.js';
export { dataUrlToBlob } from './mappers.js';

import * as auth from './auth.js';
import * as profiles from './profiles.js';
import * as account from './account.js';
import * as auftraege from './auftraege.js';
import * as rechnungen from './rechnungen.js';
import * as notifications from './notifications.js';
import * as storage from './storage.js';
import * as realtime from './realtime.js';
import * as fahrer from './fahrer.js';
import * as firma from './firma.js';
import * as admin from './admin.js';
import * as chat from './chat.js';
import * as misc from './misc.js';
import * as push from './push.js';
import * as team from './team.js';

/**
 * db — Zentrales Datenbank-API-Objekt.
 * Bündelt alle Supabase-Module (auth, profiles, auftraege, etc.) in einem
 * Namespace. Consumer nutzen `db.getProfile(id)`, `db.signIn(email, pw)` etc.
 */
export const db = {
  ...auth,
  ...profiles,
  ...account,
  ...auftraege,
  ...rechnungen,
  ...notifications,
  ...storage,
  ...realtime,
  ...fahrer,
  ...firma,
  ...admin,
  ...chat,
  ...misc,
  ...push,
  ...team,
};
